export interface IAuthRole {
    id: number,
    description: string,
    category: string
}